import * as React from 'react'

import { revivalApi } from 'redux/services/revival'
import { GetRevivalParams } from 'redux/services/revival/types'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import {
  REVIVAL_PRODUCT_NAME_TEXT,
  REVIVAL_STATUS_TEXT,
  REVIVAL_TYPE_REQUEST_TEXT,
} from 'constants/revival'
import { RevivalObject } from 'models/revival'

import {
  formatDate,
  formatNumberStringToPrice,
  formatNumberWithSpaces,
} from 'shared/libs'
import { EmptyDetails } from 'shared/ui'

import { Details } from './components/Details'
import { Filters, INITIAL_PARAMS } from './components/Filters'
import { Statistics } from './components/Statistics'

export const RevivalPage = () => {
  const [selectedRowId, setSelectedRowId] = React.useState<
    RevivalObject['id'] | undefined
  >()
  const [filters, setFilters] = React.useState<GetRevivalParams>({
    ...INITIAL_PARAMS,
    limit: 10,
    offset: 0,
  })
  const [fetch, fetchState] = revivalApi.useLazyGetRevivalQuery()

  React.useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const onChangeFilters = (newFilters: GetRevivalParams) => {
    newFilters.limit = filters.limit
    newFilters.offset = filters.offset
    setFilters(newFilters)
  }

  return (
    <>
      <AppLayoutTable
        title="Реанимация"
        header={<Filters onSubmit={onChangeFilters} />}
        statistics={<Statistics filters={filters} />}
        sidebarOpened={Boolean(selectedRowId)}
        sidebar={
          selectedRowId ? (
            <Details
              id={selectedRowId}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isFetching && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRowId,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ИНН',
                  key: 'inn',
                },
                {
                  data: 'Наименование организации',
                  key: 'name',
                },
                {
                  data: 'ФИО консультанта выполнившего реактивацию',
                  key: 'consultant_name',
                },
                {
                  data: 'ФИО супервайзера',
                  key: 'supervisor_name',
                },
                {
                  data: 'Обороты',
                  key: 'product_turnover',
                  render: (_, item) =>
                    formatNumberStringToPrice(item.product_turnover?.amount),
                },
                {
                  data: 'Период оборотов',
                  key: 'turnover_period_from',
                  render: (_, item) =>
                    `${item.turnover_period_from} - ${item.turnover_period_to}`,
                },
                {
                  data: 'Транзакции',
                  key: 'product_turnover',
                  render: (_, item) =>
                    formatNumberWithSpaces(item.product_turnover?.count),
                },
                {
                  data: 'Продукт',
                  key: 'product_name',
                  render: (_, item) =>
                    REVIVAL_PRODUCT_NAME_TEXT[item.product_name],
                },
                {
                  data: 'Статус',
                  key: 'status',
                  render: (_, item) => REVIVAL_STATUS_TEXT[item.status],
                },
                {
                  data: 'Тип заявки',
                  key: 'type_request',
                  render: (_, item) =>
                    REVIVAL_TYPE_REQUEST_TEXT[item.type_request],
                },
                {
                  data: 'Дата создания',
                  key: 'created_at',
                  render: (_, item) => formatDate(item.created_at),
                },
              ]}
            />

            <AppPagination
              forcePage={filters.offset! / filters.limit!}
              onPageChange={nextPage => {
                setFilters({
                  ...filters,
                  offset: (nextPage - 1) * filters.limit!,
                })
              }}
              count={fetchState.data.count / filters.limit!}
            />
          </>
        )}
      </AppLayoutTable>
    </>
  )
}
